(function () {
  // Prevent stacked listeners from theme hot-reload / duplicate script execution
  if (window.__geelMainAbort) {
    window.__geelMainAbort.abort();
  }
  window.__geelMainAbort = new AbortController();
  var signal = window.__geelMainAbort.signal;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { signal: signal });
    } else {
      fn();
    }
  }

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function toggleDisplay(el) {
    if (!el) return;
    var hidden = window.getComputedStyle(el).display === 'none';
    el.style.display = hidden ? '' : 'none';
  }

  function setKlaviyoMessage(form, type, text) {
    var success = form.querySelector('.success_message');
    var error = form.querySelector('.error_message');
    if (success) {
      success.hidden = type !== 'success';
      success.textContent = type === 'success' ? text : '';
      success.style.display = type === 'success' ? '' : 'none';
    }
    if (error) {
      error.hidden = type !== 'error';
      error.textContent = type === 'error' ? text : '';
      error.style.display = type === 'error' ? '' : 'none';
    }
  }

  var KLAVIYO_HEADERS = {
    accept: 'application/vnd.api+json',
    'content-type': 'application/vnd.api+json',
    revision: '2025-10-15'
  };

  function parseKlaviyoError(text, fallback) {
    var message = fallback || 'Something went wrong. Please try again.';
    try {
      var payload = text ? JSON.parse(text) : null;
      if (payload && payload.errors && payload.errors[0]) {
        var first = payload.errors[0];
        if (typeof first === 'string') return first;
        if (first.detail) return first.detail;
      }
    } catch (err) {}
    return message;
  }

  function upsertKlaviyoProfile(companyId, attributes) {
    return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: KLAVIYO_HEADERS,
      body: JSON.stringify({
        data: {
          type: 'profile',
          attributes: attributes
        }
      })
    }).then(function (response) {
      if (response.status === 202 || response.ok) return;
      return response.text().then(function (text) {
        throw new Error(parseKlaviyoError(text));
      });
    });
  }

  function subscribeKlaviyoEmailList(companyId, listId, profileAttributes) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: KLAVIYO_HEADERS,
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Website newsletter',
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      })
    }).then(function (response) {
      if (response.status === 202 || response.ok) return;
      return response.text().then(function (text) {
        throw new Error(parseKlaviyoError(text));
      });
    });
  }

  function phoneListPlaceholderEmail(phoneNumber) {
    return 'sms.' + String(phoneNumber || '').replace(/\D/g, '') + '@geel.us';
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('js-klaviyo-subscribe')) return;
      e.preventDefault();
      if (form.getAttribute('data-submitting') === 'true') return;

      var emailInput = form.querySelector('[name="email"]');
      var nameInput = form.querySelector('[name="first_name"]');
      var phoneInput = form.querySelector('[name="phone_number"]');
      var email = emailInput ? String(emailInput.value || '').trim() : '';
      var firstName = nameInput ? String(nameInput.value || '').trim() : '';
      var phoneRaw = phoneInput ? String(phoneInput.value || '').trim() : '';
      var emailListId = form.getAttribute('data-klaviyo-list') || 'SnNLmp';
      var phoneListId = form.getAttribute('data-klaviyo-phone-list') || 'R8ReQr';
      var companyId = form.getAttribute('data-klaviyo-company') || 'Y7fftH';
      var submitBtn = form.querySelector('[type="submit"]');

      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setKlaviyoMessage(form, 'error', 'Please enter a valid email.');
        if (emailInput) emailInput.focus();
        return;
      }

      var phoneNumber = '';
      if (phoneRaw) {
        var compact = phoneRaw.replace(/[()\s.-]/g, '');
        if (compact.indexOf('00') === 0) compact = '+' + compact.slice(2);
        var digits = compact.replace(/\D/g, '');
        if (compact.charAt(0) !== '+' || digits.length < 8 || digits.length > 15) {
          setKlaviyoMessage(form, 'error', 'Please enter a valid phone number with country code.');
          if (phoneInput) phoneInput.focus();
          return;
        }
        phoneNumber = '+' + digits;
      }

      if (!email && !phoneNumber) {
        setKlaviyoMessage(form, 'error', 'Please enter your email or phone.');
        if (emailInput) emailInput.focus();
        return;
      }

      form.setAttribute('data-submitting', 'true');
      if (submitBtn) submitBtn.disabled = true;
      setKlaviyoMessage(form, '', '');

      var profileAttrs = {};
      if (email) profileAttrs.email = email;
      else if (phoneNumber) profileAttrs.email = phoneListPlaceholderEmail(phoneNumber);
      if (phoneNumber) profileAttrs.phone_number = phoneNumber;
      if (firstName) profileAttrs.first_name = firstName;

      var emailAttrs = null;
      var phoneListAttrs = null;
      if (email) {
        emailAttrs = {
          email: email,
          subscriptions: {
            email: {
              marketing: { consent: 'SUBSCRIBED' }
            }
          }
        };
        if (firstName) emailAttrs.first_name = firstName;
      }
      if (phoneNumber) {
        phoneListAttrs = {
          email: email || phoneListPlaceholderEmail(phoneNumber),
          phone_number: phoneNumber,
          subscriptions: {
            email: {
              marketing: { consent: 'SUBSCRIBED' }
            }
          }
        };
        if (firstName) phoneListAttrs.first_name = firstName;
      }

      var chain = upsertKlaviyoProfile(companyId, profileAttrs);
      if (emailAttrs) {
        chain = chain.then(function () {
          return subscribeKlaviyoEmailList(companyId, emailListId, emailAttrs);
        });
      }
      if (phoneListAttrs) {
        chain = chain.then(function () {
          return subscribeKlaviyoEmailList(companyId, phoneListId, phoneListAttrs);
        });
      }

      chain
        .then(function () {
          form.classList.add('is-success');
          setKlaviyoMessage(
            form,
            'success',
            email ? 'Please look out for the confirmation email.' : "You're subscribed."
          );
          if (window.GeelCookie) GeelCookie.set('cookies', '1');
          if (form.querySelector('#newsletter-pop-up-close')) {
            setTimeout(function () {
              form.style.display = 'none';
            }, 5000);
          }
        })
        .catch(function (err) {
          form.removeAttribute('data-submitting');
          if (submitBtn) submitBtn.disabled = false;
          var message = (err && err.message) || 'Something went wrong. Please try again.';
          if (message === 'Failed to fetch' || /NetworkError/i.test(message)) {
            message = 'Something went wrong. Please try again.';
          }
          setKlaviyoMessage(form, 'error', message);
        });
    },
    { signal: signal }
  );

  // One delegated click handler for all interactive UI
  document.addEventListener(
    'click',
    function (e) {
      var closeBtn = e.target.closest('.close-cart');
      if (closeBtn) {
        var miniCartClose = document.getElementById('mini-cart');
        var menuContainer = document.getElementById('menu-container');
        var cartTriggerClose = document.getElementById('cart-trigger');
        if (miniCartClose) miniCartClose.classList.remove('active');
        if (menuContainer) menuContainer.classList.remove('show');
        if (cartTriggerClose) cartTriggerClose.classList.remove('active');
        return;
      }

      var cartTrigger = e.target.closest('#cart-trigger');
      if (cartTrigger) {
        var miniCart = document.getElementById('mini-cart');
        var nav = document.getElementById('nav');
        if (miniCart) miniCart.classList.toggle('active');
        if (nav) nav.classList.remove('active-mobile');
        document.body.classList.remove('black-header-mobile-pls');
        cartTrigger.classList.toggle('active');
        return;
      }

      var detailTrigger = e.target.closest('.detail-trigger');
      if (detailTrigger) {
        var detailNext = detailTrigger.nextElementSibling;
        if (detailNext) detailNext.classList.toggle('show');
        Array.prototype.forEach.call(detailTrigger.children, function (child) {
          if (child.tagName === 'SPAN') child.classList.toggle('toggle');
        });
        return;
      }

      var colorTrigger = e.target.closest('.other-color-trigger');
      if (colorTrigger) {
        var colorNext = colorTrigger.nextElementSibling;
        if (colorNext) colorNext.classList.toggle('show');
        Array.prototype.forEach.call(colorTrigger.children, function (child) {
          if (child.tagName === 'SPAN') toggleDisplay(child);
        });
        return;
      }

      var learnMore = e.target.closest('.learn-more-shop-pay');
      if (learnMore) {
        var shopPayPopup = document.getElementById('shop-pay-pop-up');
        if (shopPayPopup) shopPayPopup.style.display = 'block';
        return;
      }

      if (e.target.closest('#close-pop-up-shop-pay')) {
        var shopPayClose = document.getElementById('shop-pay-pop-up');
        if (shopPayClose) shopPayClose.style.display = 'none';
        return;
      }

      if (e.target.closest('#size-guide-trigger')) {
        toggleDisplay(document.getElementById('size-guide'));
        return;
      }

      var collectionTriggerEl = e.target.closest('.collection-trigger');
      if (collectionTriggerEl) {
        toggleDisplay(collectionTriggerEl.nextElementSibling);
        return;
      }

      if (e.target.closest('#collection-trigger')) {
        var menu = document.getElementById('menu-container');
        if (menu) menu.classList.toggle('show');
        return;
      }

      if (e.target.closest('#collection-filter-trigger')) {
        var filterContainer = document.getElementById('collection-filter-sort-container');
        if (filterContainer) filterContainer.classList.toggle('show');
        return;
      }

      if (e.target.closest('#collection-filter-mode')) {
        var modeBtn = document.getElementById('collection-filter-mode');
        qsa('.current-mode', modeBtn).forEach(function (mode) {
          mode.classList.toggle('small-mode-on');
          mode.classList.toggle('large-mode-on');
        });
        qsa('.collection-grid').forEach(function (grid) {
          grid.classList.toggle('small-grid');
          grid.classList.toggle('large-grid');
        });
        return;
      }

      if (e.target.closest('#burger')) {
        var burger = document.getElementById('burger');
        if (burger) burger.classList.toggle('active');
        var miniCartBurger = document.getElementById('mini-cart');
        var navBurger = document.getElementById('nav');
        if (miniCartBurger) miniCartBurger.classList.remove('active');
        if (navBurger) navBurger.classList.toggle('active-mobile');
        document.body.classList.toggle('black-header-mobile-pls');
        return;
      }

      if (e.target.closest('#footer-trigger-mobile')) {
        qsa('footer').forEach(function (footer) {
          footer.classList.toggle('active');
        });
      }
    },
    { signal: signal }
  );

  ready(function () {
    try {
      qsa('.available-size-grid').forEach(function (el) {
        var datacolor = el.getAttribute('data-color');
        var text = el.textContent;
        if (datacolor == text) {
          el.style.display = 'none';
        }
      });

      // SHOP CATEGORIES
      var elem = document.getElementById('nav-shop');
      var shopCategories = document.getElementById('shop-categories');
      if (elem && shopCategories) {
        var rect = elem.getBoundingClientRect();
        shopCategories.style.paddingLeft = rect.x + 'px';

        function showCats() {
          shopCategories.classList.add('show');
        }
        function hideCats() {
          shopCategories.classList.remove('show');
        }

        elem.addEventListener('mouseenter', showCats, { signal: signal });
        elem.addEventListener('mouseleave', hideCats, { signal: signal });
        shopCategories.addEventListener('mouseenter', showCats, { signal: signal });
        shopCategories.addEventListener('mouseleave', hideCats, { signal: signal });

        elem.addEventListener(
          'click',
          function (e) {
            if (window.innerWidth <= 820) {
              elem.insertAdjacentElement('afterend', shopCategories);
              shopCategories.classList.toggle('super-show');
              e.preventDefault();
            }
          },
          { signal: signal }
        );
      }

      // SEARCH
      qsa('.search-input-text').forEach(function (input) {
        input.addEventListener(
          'focus',
          function () {
            input.classList.add('focus');
            var logo = document.getElementById('logo');
            if (logo) logo.classList.add('move');
          },
          { signal: signal }
        );
        input.addEventListener(
          'blur',
          function () {
            input.classList.remove('focus');
            var logo = document.getElementById('logo');
            if (logo) logo.classList.remove('move');
          },
          { signal: signal }
        );
        input.addEventListener(
          'keyup',
          function () {
            var logo = document.getElementById('logo');
            if (input.value !== '') {
              qsa('.search-input-text').forEach(function (el) {
                el.classList.add('superfocus');
              });
              if (logo) logo.classList.add('supermove');
            } else {
              qsa('.search-input-text').forEach(function (el) {
                el.classList.remove('superfocus');
              });
              if (logo) logo.classList.remove('supermove');
            }
          },
          { signal: signal }
        );
      });

      var firstSearch = qs('.search-input-text');
      if (firstSearch && firstSearch.value !== '') {
        qsa('.search-input-text').forEach(function (el) {
          el.classList.add('superfocus');
        });
        var logoInit = document.getElementById('logo');
        if (logoInit) logoInit.classList.add('supermove');
      }

      // HEIGHT VIEWPORT
      function setViewportHeight() {
        document.documentElement.style.setProperty(
          '--viewport-height',
          document.documentElement.clientHeight + 'px'
        );
      }
      setViewportHeight();
      window.addEventListener('resize', setViewportHeight, { signal: signal });

      // NEWSLETTER
      // Popup markup lives in <template> so #subscribe-form-quote is not painted
      // during load / Lighthouse (it was becoming LCP with ~5s render delay).
      var newsletterMounted = false;
      function mountNewsletterPopup() {
        if (newsletterMounted || signal.aborted) return;
        var tpl = document.getElementById('newsletter-popup-template');
        if (!tpl) return;
        newsletterMounted = true;
        document.body.appendChild(tpl.content.cloneNode(true));
        tpl.remove();
        var popup = document.getElementById('subscribe-form-pop-up');
        if (!popup) return;
        popup.style.display = 'block';
        var newsletterClose = document.getElementById('newsletter-pop-up-close');
        if (newsletterClose) {
          newsletterClose.addEventListener('click', function () {
            popup.style.display = 'none';
            if (window.GeelCookie) GeelCookie.set('cookies', '1');
          });
        }
      }
      var galleta = window.GeelCookie ? GeelCookie.get('cookies') : undefined;
      if (!(galleta != undefined && galleta != '')) {
        var onEngage = function () {
          setTimeout(mountNewsletterPopup, 1500);
        };
        ['pointerdown', 'keydown'].forEach(function (evt) {
          window.addEventListener(evt, onEngage, {
            once: true,
            passive: true,
            signal: signal
          });
        });
      }

      // LAZY LOADING
      var lazyEls = qsa('.lazy');
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var l = entry.target;
            if (l.tagName == 'IMG') {
              setTimeout(function () {
                if (l.dataset.src) l.src = l.dataset.src;
              }, 500);
            }
            if (l.tagName == 'VIDEO') {
              var playPromise = l.play();
              if (playPromise !== undefined) {
                playPromise.catch(function () {
                  l.controls = true;
                  l.classList.add('no-autoplay');
                });
              }
            }
            l.classList.remove('lazy');
            observer.unobserve(l);
          });
        });
        lazyEls.forEach(function (l) {
          observer.observe(l);
        });
        signal.addEventListener('abort', function () {
          observer.disconnect();
        });
      }

      try {
        if (typeof Marquee3k !== 'undefined') {
          Marquee3k.init({ selector: 'marquee3k' });
        }
      } catch (err) {}
    } catch (err) {
      console.error('main.js init error', err);
    }
  });

  window.addEventListener(
    'scroll',
    function () {
      var bar = document.getElementById('announcement-bar');
      if (!bar) return;
      if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 15) {
        bar.classList.add('hide');
      } else {
        bar.classList.remove('hide');
      }
    },
    { signal: signal }
  );
})();
